import { render, staticRenderFns } from "./Trivia9.vue?vue&type=template&id=9b04ab2c&scoped=true&"
import script from "./Trivia9.vue?vue&type=script&lang=js&"
export * from "./Trivia9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b04ab2c",
  null
  
)

export default component.exports